import { lifecycle, compose } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { actions, getUser } from "../../modules/auth";

export const withAuthCheck = lifecycle({
   componentDidMount() {
    const {
      logout,
      location,
      user,
      setLogoutInterceptor,
      history: { replace }
    } = this.props;
    if (!user) {
      logout(location).then(next => {
        replace(`/${next}`);
      });
    } else {
      setLogoutInterceptor(replace);
    }
  },
  componentDidUpdate(prevProps) {
    const {
      logout,
      location,
      user,
      setLogoutInterceptor,
      history: { replace }
    } = this.props;
    if (!user) {
      logout(location).then(next => {
         replace(`/${next}`);
      });
    } else {
      setLogoutInterceptor(replace);
    }
  }
});

const mapStateToProps = state => ({ user: getUser(state) });

const mapDispatchToProps = {
  logout: actions.logout,
  setLogoutInterceptor: actions.setLogoutInterceptor
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withAuthCheck
);
